/**
  * @function evalute - evaluate constantBehavior
  */

const evaluate = async source => {
  const {
    value
  } = source;
  return value;
};
module.exports = {
  evaluate
};